import Card from './components/Card/Card.css';
import Menu from './components/Menu/Menu.css';
import Header from './components/Header/Header.css';
import FfpInfo from './components/FfpInfo/FfpInfo.css';
import Footer from './components/Footer/Footer.css';
import LoyaltyInfo from './components/LoyaltyInfoV2.css';

export default {
	Card,
	Menu,
	FfpInfo,
	LoyaltyInfo,
	Header,
	Footer
};
